<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      auto-resize
      border="none"
      :data="orderListData"
      align="center"
    >
      <vxe-table-column field="buyerOrdersNum" title="子订单编号" min-width="120">
        <template slot-scope="{ row }">
          <a @click="openOrderDetail(row.id, 1)">{{ row.buyerOrdersNum }}</a>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="salesManName"
        title="业务员"
        width="100"
      ></vxe-table-column>
      <!-- <vxe-table-column field="contractNum" title="关联合同" min-width="120">
        <template slot-scope="{ row }">
          <a @click="showDetail(row.contractId)" style="color: #2d8cf0">{{
            row.contractNum
          }}</a>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="contractBusType" title="业务类型" min-width="80">
        <template slot-scope="{ row }">
          <span>{{ row.contractBusType | contractbusMap }}</span>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="contractTitle" title="订单标题"></vxe-table-column> -->
      <!-- <vxe-table-column field="addTime" title="签约日期" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.addTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column> -->
      <vxe-table-column
        field="buyerName"
        title="托运人名称"
        min-width="160"
      ></vxe-table-column>
      <!-- <vxe-table-column field="amountTotal" title="金额" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.amountTotal | formatMoney }}</span>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="goodsRtnVos" title="签约日期" min-width="100">
        <template slot-scope="{ row, $rowIndex }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].addTime | timeFormatDate
          }}</span>
          <Icon
            type="ios-arrow-down"
            @click="clickEvent3($rowIndex)"
            v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
          />
          <vxe-pulldown
            :ref="$rowIndex"
            transfer
            placement="bottom"
            size="small"
          >
            <template v-slot:dropdown>
              <div class="my-dropdown3">
                <vxe-table
                  :data="row.goodsRtnVos"
                  auto-resize
                  stripe
                  show-overflow
                  align="center"
                  :show-header="false"
                >
                  <vxe-table-column field="addTime" title="签约日期" width="100">
                    <template slot-scope="{ row }">
                      <span>{{ row.addTime | timeFormatDate }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="goodsName" title="货名" width="80"></vxe-table-column>
                  <!--                  <vxe-table-column-->
                  <!--                    field="rule"-->
                  <!--                    title="规格"-->
                  <!--                     width="8%"-->
                  <!--                  ></vxe-table-column>-->
                  <vxe-table-column field="unit" title="单位" width="60"></vxe-table-column>
                  <vxe-table-column field="counts" title="数量" width="60"></vxe-table-column>
                  <vxe-table-column field="price" title="单价" width="70"></vxe-table-column>
                  <vxe-table-column field="amount" title="金额" width="70"></vxe-table-column>
                  <vxe-table-column field="priceType" title="计费方式" width="80">
                    <template slot-scope="{ row }">
                      <span>{{ row.priceType | priceTypeMap }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="isTax" title="含税" width="60">
                    <template slot-scope="{ row }">
                      <span>{{ row.isTax | taxMap }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="carShipNum" title="车船号" width="70"></vxe-table-column>
                  <vxe-table-column field="beginPlace" title="起运地" width="70"></vxe-table-column>
                  <vxe-table-column field="beginTime" title="受载/起运时间" width="120">
                    <template slot-scope="{ row }">
                      <span>{{ row.beginTime | timeFormatDate }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="endPlace" title="到达地" width="70"></vxe-table-column>
                  <vxe-table-column field="endTime" title="到达时间" width="120">
                  <template slot-scope="{ row }">
                      <span>{{ row.endTime | timeFormatDate }}</span>
                    </template>
                  </vxe-table-column>
                  <!-- <vxe-table-column
                    field="driverName"
                    title="司机"
                    width="80"
                  ></vxe-table-column>
                  <vxe-table-column
                    field="driverPhone"
                    title="手机号"
                    width="100"
                  ></vxe-table-column> -->
                </vxe-table>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="货物类型" min-width="120">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].goodsType
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="货名" min-width="80">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].goodsName
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="单位" min-width="60">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].unit }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="数量" min-width="60">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].counts }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="单价" min-width="70">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].price }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="金额" min-width="70">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].amount }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="计费方式" min-width="80">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].priceType | priceTypeMap
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="含税" min-width="60">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].isTax | taxMap
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="车船号" min-width="70">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].carShipNum
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="起运地" min-width="70">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].beginPlace
          }}</span>
        </template>
      </vxe-table-column>
      
      <vxe-table-column field="goodsRtnVos" title="受载/起运时间" min-width="120">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].beginTime | timeFormatDate
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="到达地" min-width="70">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].endPlace
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="到达时间" min-width="120">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].endTime | timeFormatDate
          }}</span>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="goodsRtnVos" title="司机" width="80">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].driverName
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="手机号" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].driverPhone
          }}</span>
        </template>
      </vxe-table-column> -->
    </vxe-table>
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      auto-resize
      show-overflow
      border="none"
      :data="AmountData"
      align="center"
    >
      <vxe-table-column
        field="associateCounts"
        title="实际数量"
      ></vxe-table-column>
      <vxe-table-column field="receivablesAmount" title="应收金额">
        <template slot-scope="{ row }">
          <span>{{ row.receivablesAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="receivedAmount" title="已收金额">
        <template slot-scope="{ row }">
          <span>{{ row.receivedAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="uncollectedAmount" title="未收金额">
        <template slot-scope="{ row }">
          <span>{{ row.uncollectedAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="invoiceCount"
        title="发票关联数"
      ></vxe-table-column>
      <vxe-table-column field="invoiceAmount" title="发票总额">
        <template slot-scope="{ row }">
          <span>{{ row.invoiceAmount | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal
      v-model="viewBuyer"
      title="查看托运人合同"
      width="1300"
      height="650"
      @close="closeDetail"
      resize
      remember
    >
      <view-detail-modal
        ref="modalDetail"
        :editVisible="isHavePermission('buyer:updateContract')"
        @goEdit="goEdit"
      ></view-detail-modal>
    </vxe-modal>
    <vxe-modal
      v-model="visible"
      :title="modalTitle"
      width="1300"
      height="650"
      @close="closeCreate"
      resize
      remember
    >
      <create-buyer-modal ref="modalCreate" @close="close"></create-buyer-modal>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import ViewDetailModal from "@/views/agreement/ViewDetailModal";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import CreateBuyerModal from "@/views/agreement/CreateBuyerModal";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization, viewOrderDetail],
  props: {
    id: Number,
  },
  components: { ViewDetailModal, CreateBuyerModal },
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      orderListData: [],
      viewBuyer: false,
      visible: false,
      modalTitle: "",
    };
  },
  computed: {
    AmountData() {
      let arr = [];
      let obj = {};
      if (this.orderListData && this.orderListData.length > 0) {
        obj.associateCounts = this.orderListData.reduce((v, cur) => {
          return v + cur.associateCounts;
        }, 0);
        obj.receivablesAmount = this.orderListData.reduce((v, cur) => {
          return v + cur.receivablesAmount;
        }, 0);
        obj.receivedAmount = this.orderListData.reduce((v, cur) => {
          return v + cur.receivedAmount;
        }, 0);
        obj.uncollectedAmount = this.orderListData.reduce((v, cur) => {
          return v + cur.uncollectedAmount;
        }, 0);
        obj.invoiceCount = this.orderListData.reduce((v, cur) => {
          return v + cur.invoiceCount;
        }, 0);
        obj.invoiceAmount = this.orderListData.reduce((v, cur) => {
          return v + cur.invoiceAmount;
        }, 0);
      }
      arr.push(obj);
      return arr;
    },
  },
  watch: {
    id(nv, ov) {
      nv !== ov ? this.getOrderList() : "";
    },
  },
  created() {
    this.getOrderList();
    // this.$bus.$on("allOrderDetailRenovate", (data) => {
    //   data === true ? this.getOrderList() : "";
    // });
  },
  methods: {
    clickEvent3(id) {
      this.$refs[id].togglePanel();
    },
    getOrderList() {
      // 获取列表数据
      $api.order.queryOrdersBuyerListModel
        .POST({
          data: {
            chainId: this.id,
            page: this.page.currentPage,
            rows: this.page.pageSize,
          },
        })
        .then((res) => {
          if (res.status === 1) {
            this.page.totalResult = res.data.total;
            this.orderListData = res.data.rows;
            this.$emit("buyerOrderLength", res.data.rows.length);
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        });
    },
    showDetail(id) {
      if (!this.isHavePermission('buyer:queryContractDetail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.viewBuyer = true;
      this.contractId = id;
      this.$refs.modalDetail.queryContractDetail(id);
    },
    closeDetail() {
      this.$refs.modalDetail.close();
    },
    goEdit() {
      this.modalTitle = "编辑托运人合同";
      this.visible = true;
      this.$refs.modalCreate.queryContractDetail(this.contractId);
    },
    closeCreate() {
      this.$refs.modalCreate.close();
    },
    close(value) {
      if (value === "add") {
        this.visible = false;
      } else if (value === "update") {
        this.visible = false;
        this.viewBuyer = false;
        this.$refs.modalDetail.close();
      }
      this.getOrderList();
    },
  },
};
</script>

<style scoped>
.table-style .ivu-icon-ios-arrow-down {
  right: 0;
}

.list-box {
  width: 100%;
}

.my-dropdown3 {
  width: 1030px;
}
</style>